import { useState } from "react";
import Button from "../base/Button";

export default function Header() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isSolutionsDropdownOpen, setIsSolutionsDropdownOpen] = useState(false);

  const openContactModal = () => {
    setIsContactModalOpen(true);
  };

  const closeContactModal = () => {
    setIsContactModalOpen(false);
  };

  const toggleSolutionsDropdown = () => {
    setIsSolutionsDropdownOpen(!isSolutionsDropdownOpen);
  };

  const handleNavigation = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string,
  ) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "instant" });
    window.REACT_APP_NAVIGATE(href);
    setIsSolutionsDropdownOpen(false);
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="/" className="flex items-center">
                <img
                  src="/images/logo-moveideias.png"
                  alt="Moveideias"
                  className="h-10 w-auto"
                />
              </a>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex space-x-8">
              <a
                href="/"
                onClick={(e) => handleNavigation(e, "/")}
                className="text-[#221a32] hover:text-[#f28c1a] transition-colors duration-200 font-medium"
              >
                Home
              </a>
              <a
                href="/quem-somos"
                onClick={(e) => handleNavigation(e, "/quem-somos")}
                className="text-[#221a32] hover:text-[#f28c1a] transition-colors duration-200 font-medium"
              >
                Quem somos
              </a>
              <div className="relative">
                <button
                  onClick={toggleSolutionsDropdown}
                  className="text-[#221a32] hover:text-[#f28c1a] transition-colors duration-200 font-medium flex items-center cursor-pointer"
                >
                  Nossas soluções
                  <i
                    className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${
                      isSolutionsDropdownOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {isSolutionsDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-100 py-2 z-50">
                    <a
                      href="/teupedido"
                      onClick={(e) => handleNavigation(e, "/teupedido")}
                      className="block px-4 py-3 text-[#221a32] hover:bg-[#e7eaf6] hover:text-[#ea5836] transition-colors"
                    >
                      <div className="flex items-center">
                        <div className="w-8 h-8 bg-[#ea5836] rounded-full flex items-center justify-center mr-3">
                          <i className="ri-shopping-cart-line text-sm text-white" />
                        </div>
                        <div>
                          <div className="font-medium">TeuPedido</div>
                          <div className="text-xs text-gray-500">
                            Gestão logística end-to-end
                          </div>
                        </div>
                      </div>
                    </a>
                    <a
                      href="/movecourier"
                      onClick={(e) => handleNavigation(e, "/movecourier")}
                      className="block px-4 py-3 text-[#221a32] hover:bg-[#e7eaf6] hover:text-[#4bb5ab] transition-colors"
                    >
                      <div className="flex items-center">
                        <div className="w-8 h-8 bg-[#4bb5ab] rounded-full flex items-center justify-center mr-3">
                          <i className="ri-truck-line text-sm text-white" />
                        </div>
                        <div>
                          <div className="font-medium">MoveCourier</div>
                          <div className="text-xs text-gray-500">
                            Gestão last mile
                          </div>
                        </div>
                      </div>
                    </a>
                    <a
                      href="/movepipe"
                      onClick={(e) => handleNavigation(e, "/movepipe")}
                      className="block px-4 py-3 text-[#221a32] hover:bg-[#e7eaf6] hover:text-[#5a6ab0] transition-colors"
                    >
                      <div className="flex items-center">
                        <div className="w-8 h-8 bg-[#5a6ab0] rounded-full flex items-center justify-center mr-3">
                          <i className="ri-flow-chart text-sm text-white" />
                        </div>
                        <div>
                          <div className="font-medium">MovePipe</div>
                          <div className="text-xs text-gray-500">
                            Workflow no-code
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                )}
              </div>
              <a
                href="https://blog.moveideias.com/blog/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#221a32] hover:text-[#f28c1a] transition-colors duration-200 font-medium cursor-pointer"
              >
                Blog
              </a>
            </nav>

            {/* CTA Button */}
            <div className="flex items-center space-x-4">
              <Button
                onClick={openContactModal}
                className="bg-[#f28c1a] text-white hover:bg-[#cc7013] transition-colors duration-200 whitespace-nowrap cursor-pointer h-11 w-[11.25rem]"
              >
                Peça um contato
              </Button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button className="text-[#221a32] hover:text-[#f28c1a] cursor-pointer">
                <i className="ri-menu-line text-xl" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-[#221a32]">
                Solicitar contato
              </h3>
              <button
                onClick={closeContactModal}
                className="text-[#221a32] hover:text-[#f28c1a] cursor-pointer"
              >
                <i className="ri-close-line text-2xl" />
              </button>
            </div>
            <div className="h-[600px]">
              <iframe
                width="100%"
                height="100%"
                src="https://portal.moveideias.com/workflow/public/form/9ec92cd7-ac11-4a04-8a8a-6d71c473e303"
                title="Formulário de Solicitação de contato"
                frameBorder="0"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
